import { CodeEditorAdapter, CodeEditorOptions, ContentOptions } from "@reporting/rp-app-host";
import rp from '@reporting/rp-app-host';
import { ReportContext } from "@reporting/rp-types/analytics";

export class ContextCodeEditorAdapter extends CodeEditorAdapter {

	public options: CodeEditorOptions = {};

	constructor(private idContext?: number) {
		super();
	}

	async getContent(opt?: ContentOptions) : Promise<string> {
		const contextData = await rp.ms('analytics').get<ReportContext>(`context/${this.idContext}`, {validate: 0});
		return JSON.stringify(contextData?.context ?? '', null, '\t');
	}

	async save(data: string): Promise<void> {
		let contextData: any;

		try {
			contextData = JSON.parse(data);
		} catch (error) {
			rp.host.showAlert({title: 'Invalid JSON', type: 'danger'});
		}

		if (contextData != null) {
			await rp.ms('analytics').put(`context/${this.idContext}`, {context: contextData}, {validate: 0});
		}
	}

	getOptions() : CodeEditorOptions {
		return this.createOptions({
			language: 'json',
			toolbar: {
				save: {
					enabled: true
				},
				discard: {
					enabled: true
				}
			}
		});
	}

}
